import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import './index.css';
import './styles/fiches-table.css';
import { applyForceDesktopViewport } from './utils/applyForceDesktopViewport';
import { initTableScrollContainment } from './utils/tableScrollContainment';
import { initMainContentIosScrollChain } from './utils/iosNestedScrollChain';
import { initViewportZoomScrollFix } from './utils/viewportZoomScrollFix';

applyForceDesktopViewport();
initTableScrollContainment();
initMainContentIosScrollChain();
initViewportZoomScrollFix();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

